import dateHelpers from "./DateHelper";

const ticketHelpers = {

    getTicketTypeStartDate: function (ticketType) {
        if (ticketType != null) {
            return dateHelpers.databaseDate(ticketType.start_first_day === true ? dateHelpers.firstDayOfMonth() : new Date());
        }
    },

    createTicketTemplate: function (ticketType, studentId) {
        return {
            start: ticketType.starts_on_use ? null : this.getTicketTypeStartDate(ticketType),
            end: ticketType.starts_on_use ? null : this.getTicketTypeEndDate(ticketType),
            name: ticketType.name,
            renewable: ticketType.renewable,
            classes_left: ticketType.classes_left,
            purchase_date: dateHelpers.databaseDate(new Date()),
            start_first_day: ticketType.start_first_day,
            is_workshop_ticket: ticketType.is_workshop,
            price: ticketType.price,
            total_classes: ticketType.classes_left,
            duration: ticketType.duration,
            units: ticketType.units,
            tt_id: ticketType.id,
            studentId: studentId,
            starts_on_use: ticketType.starts_on_use,
        }
    },
    
    getTicketTypeEndDate: function (ticketType) {
        if (ticketType != null) {
            const dur = ticketType.duration;
            const units = ticketType.units;

            if (dur === -3) {
                return "unlimited"
            }

            else if (dur && units) {
                const dateStart = ticketType.start_first_day === true ? dateHelpers.firstDayOfMonth() : new Date();
                if (units === 'm') {
                    const plusMonths = dateHelpers.addMonth(dateStart, dur);
                    const minusDay = dateHelpers.addDay(plusMonths, -1);

                    return dateHelpers.databaseDate(minusDay);
                } else {
                    const plusDays = dateHelpers.addDay(dateStart, dur);

                    return dateHelpers.databaseDate(plusDays);
                }
            }
        }
    }

};

export default ticketHelpers;